import { type FC } from 'react';

interface PaymentStatusBadgeProps {
  status: string;
}

const statusMap: Record<string, string> = {
  pending: 'bg-amber-50 text-amber-700 border-amber-200',
  active: 'bg-blue-50 text-blue-700 border-blue-200',
  paid: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  overdue: 'bg-red-50 text-red-700 border-red-200',
  cancelled: 'bg-gray-100 text-gray-500 border-gray-200',
  archived: 'bg-gray-100 text-gray-500 border-gray-200',
  'Aguardando pagamento': 'bg-amber-50 text-amber-700 border-amber-200',
  'Pago': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Parcialmente pago': 'bg-orange-50 text-orange-700 border-orange-200',
  'Vencido': 'bg-red-50 text-red-700 border-red-200',
  'Inadimplente': 'bg-red-100 text-red-800 border-red-300',
  'Cancelado': 'bg-gray-100 text-gray-500 border-gray-200',
  'Arquivado': 'bg-gray-100 text-gray-500 border-gray-200',
};

const labelMap: Record<string, string> = {
  pending: 'Pendente',
  active: 'Ativo',
  paid: 'Pago',
  overdue: 'Vencido',
  cancelled: 'Cancelado',
  archived: 'Arquivado',
};

const PaymentStatusBadge: FC<PaymentStatusBadgeProps> = ({ status }) => {
  const classes = statusMap[status] || 'bg-gray-50 text-gray-600 border-gray-200';
  const label = labelMap[status] || status;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${classes}`}>
      {label}
    </span>
  );
};

export default PaymentStatusBadge;
